import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AddCategoryComponent } from 'src/app/exam-layout/operations/add-category/add-category.component';
import { ExamOperationService } from 'src/app/exam-layout/operations/exam-operation.service';
import { IComplaintCategory, IExam } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { ComplaintService } from 'src/app/services/complaint-services.service';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { AddComplaintCategoryComponent } from '../add-complaint-category/add-complaint-category.component';

@Component({
  selector: 'app-complaint-category',
  templateUrl: './complaint-category.component.html',
  styleUrls: ['./complaint-category.component.scss']
})
export class ComplaintCategoryComponent implements OnInit {


  categories: IComplaintCategory[] = null;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  constructor(private complaintService: ComplaintService, private snackBar: SnackbarService,
    private examOps: ExamOperationService, private evnt: EventService) { }

  async ngOnInit() {
    await this.refreshCategory();
    this.evnt.adCategoryMessageEvent.subscribe(async (message: any) => {
      await this.refreshCategory();
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.evnt.adCategoryMessageEvent.unsubscribe();
  }
  addCategory(origin) {
    sessionStorage.setItem("selectedComplaintCategory", null);
    this.examOps.openModal(origin, AddComplaintCategoryComponent)
  }

  editCategory(origin, category) {
    sessionStorage.setItem("selectedComplaintCategory", JSON.stringify(category));
    this.examOps.openModal(origin, AddComplaintCategoryComponent);
  }

  async refreshCategory() {
    await this.complaintService.getComplaintCategory().then((c: any) => {
      this.categories = c;
      this.categories = this.categories.map(cat => {
        cat.helpText = cat.helpText.replace(/^"|"$/g, '');
        return cat;
      });
    });
  }

  deleteCategory(cat: any) {
    this.complaintService.deleteComplaintCategory(cat).then((response: any) => {
      this.snackBar.success('Category deleted');
      this.categories = this.categories.filter(c => c.categoryID !== cat.categoryID)
    });
  }
}
